export const MINIMUM_REQUIRED_EXTREMES = 1;
